export function calculateTotalCharge(data) {
  return Number(data.reduce((total, item) => {
    const charge1 = item?.Consolidated_TotCharge ?? item?.Invoice_ChargeTotal1 ?? 0;
    const charge2 = item?.Consolidated_OvertimeTotCharge ?? item?.Invoice_ChargeTotal2 ?? 0;
    const charge3 = item?.Consolidated_BankHolidayTotCharge ?? item?.Invoice_ChargeTotal3 ?? 0;
    const charge4 = item?.Consolidated_NightRateTotCharge ?? item?.Invoice_ChargeTotal4 ?? 0;

    return total + (Number(charge1) || 0) + (Number(charge2) || 0)+ (Number(charge3)||0)+ (Number(charge4)||0);
  }, 0)).toFixed(2);
}